import useAiOnboarding from './use-ai-onboarding';

export default {
  useAiOnboarding,
};
